import { useEffect } from 'react';
import { SaveViewButtonsPresentational } from 'customer-data-views-management/components/saveViewButtons/SaveViewButtonsPresentational';
import useCrmObjectTypeTracking from 'framework-listing-lib/internal/hooks/useCrmObjectTypeTracking';
import { useViews } from 'framework-listing-lib/internal/ViewTabs/providers/ViewsProvider';
import { useGetSaveAsNewViewProps, useIsCurrentViewReadOnly } from 'framework-listing-lib/hooks/useCurrentView';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SaveViewButton({
  onCloneClick,
  onResetClick,
  onSaveClick
}) {
  const {
    trackCrmTableInteraction
  } = useCrmObjectTypeTracking();
  const {
    isCurrentViewModified
  } = useViews();
  const isReadOnly = useIsCurrentViewReadOnly();
  const saveAsNewViewProps = useGetSaveAsNewViewProps();
  useEffect(() => {
    const handleKeyDown = event => {
      const isSaveKey = event.key === 's' && (event.ctrlKey || event.metaKey);
      if (isSaveKey) {
        event.preventDefault();
        if (isReadOnly) {
          onCloneClick();
        } else {
          onSaveClick();
        }
        trackCrmTableInteraction({
          action: 'save-view-via-shortcut'
        });
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onSaveClick, trackCrmTableInteraction, isReadOnly, onCloneClick]);
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "crm-listing-save-view-buttons",
    children: /*#__PURE__*/_jsx(SaveViewButtonsPresentational, {
      isReadOnlyView: isReadOnly,
      isModifiedView: isCurrentViewModified,
      isCloningDisabled: saveAsNewViewProps === null || saveAsNewViewProps === void 0 ? void 0 : saveAsNewViewProps.disabled,
      onCloneClick: onCloneClick,
      onResetClick: onResetClick,
      onSaveClick: onSaveClick
    })
  });
}